/* eslint-disable new-cap */
const STRAPI_URL = (): string => {
	if (typeof window === 'undefined') {
		const base = process.env.REACT_APP_STRAPI_URL;
		return base ? base.replace('%s', '') : '';
	}

	const { host } = window.location;
	const label = host.split('.')[0] ?? '';
	const env = label.split('-')[0]?.toLowerCase(); // "des" | "int" | "pre" | "local" | ""

	const base = process.env.REACT_APP_STRAPI_URL ?? 'https://%sbackoffice-madrid.notariado.org/backoffice-cnm';

	if (env === 'local') return 'https://local.notariado.org';

	// Producción: sin prefijo
	if (!['des', 'int', 'pre'].includes(env)) return base.replace('%s', '');

	return base.replace('%s', `${env}-`);
};

const STRAPI_ASSETS_URL = (): string => {
	if (typeof window === 'undefined') {
		const base = process.env.REACT_APP_STRAPI_ASSETS_URL;
		return base ? base.replace('%s', '') : '';
	}

	const { host } = window.location;
	const label = host.split('.')[0] ?? '';
	const env = label.split('-')[0]?.toLowerCase();

	const base = process.env.REACT_APP_STRAPI_ASSETS_URL ?? 'https://%sbackoffice-madrid.notariado.org';

	if (env === 'local') return 'https://local.notariado.org';

	if (!['des', 'int', 'pre'].includes(env)) return base.replace('%s', '');

	return base.replace('%s', `${env}-`);
};

export const apiUrl = `${STRAPI_URL()}/api`;
export const assetsUrl: string = STRAPI_ASSETS_URL();

export const accessToken: string = process.env.REACT_APP_STRAPI_ACCESS_TOKEN ?? '';
export const PAGINATION_SIZE: number | string = process.env.REACT_APP_PAGINATION_SIZE ?? 12;
